import { useParams } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import { categoryMetas } from "@/mocks/categories";
import Breadcrumb from "@/components/feature/Breadcrumb";
import DramaListView from "@/components/feature/DramaListView";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

export default function CategoryPage() {
  const { categoryName = "" } = useParams();
  const meta = categoryMetas.find((m) => m.name === categoryName);

  const list = dramas.filter((d) => {
    if (categoryName === "最新更新") return true;
    if (categoryName === "热门推荐") return d.hot;
    if (categoryName === "双男主影视") return d.tags.includes("双男主");
    return d.category === categoryName;
  });

  const title = `${categoryName} - 泰剧腐剧双男主`;
  const description =
    meta?.desc ?? `${categoryName}分类下的泰国双男主剧集推荐，包含剧照、主演与剧情简介，帮你快速找到想看的内容。`;
  usePageMeta(title, description);

  return (
    <div className={wrap}>
      <div className="border-b border-background-200 pt-6 pb-5">
        <Breadcrumb
          items={[{ label: "首页", to: "/" }, { label: "分类" }, { label: categoryName }]}
        />
        <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          {categoryName}
        </h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">{description}</p>
      </div>

      <div className="mt-6 pb-4">
        <DramaListView dramas={list} />
      </div>
    </div>
  );
}